module.exports = __webpack_public_path__ + "static/media/usersLight.98f66753.svg";